import {api} from '../helpers/api';
import utils from '../helpers/utils';
import {POST_CONFIG} from '../helpers/apiCalls';
import {LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE,
  TOKENS_BY_NSL_TOKEN_REQUEST, TOKENS_BY_NSL_TOKEN_SUCCESS, TOKENS_BY_NSL_TOKEN_FAILURE} from './authConstants';

function loginRequest() {
  return {
    type: LOGIN_REQUEST,
  };
}

function loginSuccess(result) {
  return (dispatch) => {
    return dispatch({
      type: LOGIN_SUCCESS,
      user: result,
    });
  }
}

function loginFailure(error) {
  return {
    type: LOGIN_FAILURE,
    error,
  };
}

export function loginRefresh() {

  let url = utils.getMembersPath();

  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'client_id': 'cct'
    },
    credentials: 'include',
  };
  return api(url, config, loginRequest(), loginSuccess, loginFailure);
}

function tokensByNslTokenRequest() {
  return {
    type: TOKENS_BY_NSL_TOKEN_REQUEST
  }
}

function tokensByNslTokenSuccess(_result) {
  return (dispatch) => {
    return dispatch({
      type: TOKENS_BY_NSL_TOKEN_SUCCESS
    });
  }
}

function tokensByNslTokenFailure(error) {
  return {
    type: TOKENS_BY_NSL_TOKEN_FAILURE,
    error
  }
}

export function tokensByNslToken(nslAccessToken) {
  let url = utils.tokensByNslTokenPath();
  let postConfig = {body: JSON.stringify({appType:'CCT',nsl_access_token:nslAccessToken})};
  Object.assign(postConfig, POST_CONFIG);
  return api(url, postConfig, tokensByNslTokenRequest, tokensByNslTokenSuccess, tokensByNslTokenFailure);
}






// WEBPACK FOOTER //
// ./src/actions/auth.js